import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import { ContextMenuPlugin } from '@/plugins/context-menu';
import { IExportPlugin, PluginType } from '@/version-types';
import { clipboardCopyItem } from './clipboard-copy-item';
import { clipboardCutItem } from './clipboard-cut-item';
import { clipboardPasteItem } from './clipboard-paste-item';

const ClipboardContextMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addContextMenu([
            {
                key: 'copy',
                group: 1,
                sort: 4,
                render: clipboardCopyItem,
            },
            {
                key: 'cut',
                group: 1,
                sort: 5,
                render: clipboardCutItem,
            },
            {
                key: 'paste',
                group: 1,
                sort: 6,
                render: clipboardPasteItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'clipboard-context-menu',
    render() {
        return <ClipboardContextMenuView />;
    },
};

export default exportPlugin;
